// extracted by mini-css-extract-plugin
module.exports = {"pd-meta-tab-swiper":"tab-swiper_pd-meta-tab-swiper__eUOvn"};